
import React from "react";

const VoucherSkeleton = () => {
  return (
    <div
      data-aos="flip-up"
      className="voucher_card p-2 bg_grey_light br_10 d-flex flex-row gap-3"
      style={{ opacity: 0.5 }}
    >
      {/* Placeholder for image */}
      <div className="br_10 skeleton-box" style={{ width: "80px", height: "80px" }}></div>

      {/* Placeholder for text */}
      <div className="d-flex flex-column justify-content-between w-100">
        <div className="skeleton-box " style={{ width: "100px", height: "20px" }}></div>
        <div className="skeleton-box" style={{ width: "60px", height: "20px" }}></div>

        {/* Placeholder for buttons */}
        <div className="d-flex w-100 gap-3 flex-wrap">
          <div className="skeleton-box" style={{ width: "70px", height: "30px" }}></div>
          <div className="skeleton-box" style={{ width: "70px", height: "30px" }}></div>
        </div>
      </div>
    </div>
  );
};

export default VoucherSkeleton;
